import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dcf49c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReplenishAdd" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "项目完结情况", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "协议说明")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, [
    /*#__PURE__*/_createTextVNode("合同附件 "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999999","font-size":"12px"} }, "（可上传图片、word、excel、pdf）")
  ])
], -1))
const _hoisted_9 = {
  key: 0,
  class: "uploader"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_11 = {
  key: 1,
  class: "uploader"
}
const _hoisted_12 = { class: "self_flex_row self_justify_between self_align_center" }
const _hoisted_13 = { class: "self_flex_row self_align_center" }
const _hoisted_14 = { class: "image" }
const _hoisted_15 = { class: "file_type" }
const _hoisted_16 = { class: "type-rd" }
const _hoisted_17 = { style: {"font-size":"10px"} }
const _hoisted_18 = {
  class: "",
  style: {"color":"#000000"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_21 = { class: "submit-btn" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 提交 ")

import SimpImageUpload from '@/components/SimpImageUpload.vue'
import { saveProject, AgreementSave } from '@/apis/replenish'
import { Toast } from 'vant'
import { onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { uploadFileItem } from '@/apis/base'
import dayjs from 'dayjs'
import { ApproveConfig, CarboncopyConfig } from '@/apis/public/oauth'
import { uploadFile1 } from '@/apis/public/file'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const showFile = ref(false)
const state = reactive({
  suffixName: '',
  suffixSize: '',
  name: '',
  formData: {} as saveProject
})

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  console.log('ticket add fileList ===>', newVal)
  // data.saveData.upload_file_list = newVal
  state.formData.pics = newVal
})

//上传文件
const afterRead = (file: any) => {
  Toast.loading({
    message: '上传中...',
    forbidClick: true,
    duration: 0
  })
  console.log('afterRead.file ===>', file)
  state.suffixName = file.file.name.substring(file.file.name.lastIndexOf('.') + 1)
  console.log('====substring>', state.suffixName)

  state.formData.name = file.file.name
  state.formData.size = sizeTostr(file.file.size)
  // 循环上传
  file.status = 'uploading'
  file.message = '上传中...'

  const param = new FormData()
  param.append('uploadFile', file.file, file.file.name)

  uploadFile1(param).then((res: any) => {
    if (res.code == 200) {
      state.formData.attachment = res.data.url
      file.status = 'done'
      file.message = '上传成功'
      Toast.clear()
      showFile.value = true
    } else {
      file.status = 'failed'
      file.message = '上传失败'
    }
  })
}

const to_clear = () => {
  showFile.value = false
  state.formData.attachment = ''
}

const sizeTostr = size => {
  var data = ''
  if (size < 0.1 * 1024) {
    //如果小于0.1KB转化成B
    data = size.toFixed(2) + 'B'
  } else if (size < 0.1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(2) + 'KB'
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    //其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  var sizestr = data + ''
  var len = sizestr.indexOf('\.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

const onSubmit = async () => {
  const res = await AgreementSave(state.formData)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    if (res.msg) Toast(res.msg)
  }
}

const review_carbon = ref({
  review: [],
  carbon: []
})

const get_approve_config = async () => {
  let typeId = {
    type: 5
  }
  const res = await ApproveConfig(typeId)
  const res1 = await CarboncopyConfig(typeId)
  if (res.code === 200) {
    if (res.data) {
      res.data.forEach(e => {
        review_carbon.value.review.push(e.staff)
      })
    }
  }
  if (res1.code === 200) {
    if (res1.data) {
      res1.data.forEach(e => {
        review_carbon.value.carbon.push(e.staff)
      })
    }
  }
}
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  get_approve_config()
  state.name = router.currentRoute.value.query.project_name.toString()
  state.formData.project_id = router.currentRoute.value.query.project_id.toString()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_review_people = _resolveComponent("review-people")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell, {
                title: "项目名称",
                value: _unref(state).name
              }, null, 8, ["value"]),
              _hoisted_3,
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.money,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.money) = $event)),
                    "label-width": "150",
                    label: "补充合同金额（元）",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_cell, { title: "协议说明" }, {
                    title: _withCtx(() => [
                      _hoisted_4
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        modelValue: _unref(state).formData.explain,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).formData.explain) = $event)),
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入说明",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_5,
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, { title: "图片" }, {
                    title: _withCtx(() => [
                      _hoisted_6
                    ]),
                    label: _withCtx(() => [
                      _createVNode(SimpImageUpload, {
                        isShowTitle: false,
                        modelValue: fileList.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fileList).value = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_7,
                  _createVNode(_component_van_cell, null, {
                    title: _withCtx(() => [
                      _hoisted_8
                    ]),
                    label: _withCtx(() => [
                      (!showFile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_van_uploader, {
                              "after-read": afterRead,
                              accept: "*"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_button, {
                                  icon: "plus",
                                  type: "primary",
                                  block: "",
                                  plain: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  (_unref(state).suffixName == 'pdf' || _unref(state).suffixName == 'pptx' || _unref(state).suffixName == 'ppt')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 0,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/pdf.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (_unref(state).suffixName == 'docx' || _unref(state).suffixName == 'doc')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 1,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/word.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (_unref(state).suffixName == 'xlsx' || _unref(state).suffixName == 'xls')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 2,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/excel.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (
                            _unref(state).suffixName == 'jpeg' ||
                            _unref(state).suffixName == 'gif' ||
                            _unref(state).suffixName == 'png' ||
                            _unref(state).suffixName == 'jpg'
                          )
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 3,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/pisc.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(state).suffixName), 1),
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(state).formData.size), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_van_icon, {
                                  onClick: to_clear,
                                  name: "clear"
                                })
                              ])
                            ])
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_19,
          _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
          _hoisted_20,
          _createVNode(_component_review_people, { review_carbon: review_carbon.value }, null, 8, ["review_carbon"]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})